import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "./api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [state, setState] = useState({ loading: true, user: null, stores: [], subscription: null });
  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setState({ loading: false, ...r.data });
      return r.data;
    } catch {
      setState({ loading: false, user: null, stores: [], subscription: null });
      return null;
    }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  const logout = async () => {
    await api.post("/auth/logout");
    setState({ loading: false, user: null, stores: [], subscription: null });
  };
  return <AuthCtx.Provider value={{ ...state, refresh, logout, setState }}>{children}</AuthCtx.Provider>;
}

export const homeFor = (d, next) => (d.user.role === "super_admin" && !d.stores.length ? "/super-admin/dashboard" : !d.stores.length ? "/app/onboarding" : next || "/app/dashboard");

export function Protected({ children, role }) {
  const { loading, user } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="min-h-screen grid place-items-center text-sm text-slate-500" data-testid="auth-loading">Loading…</div>;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  if (role === "super_admin" && user.role !== "super_admin") return <Navigate to="/app/dashboard" replace />;
  return children;
}
